import React, {useCallback, useState} from 'react';
import {Col, Container, Row, Button} from 'reactstrap';
import FacebookCommentFeed from 'components/Social/FacebookCommentFeed';
import classNames from 'classnames';
import './CommentSection.scss';
import SectionCL from 'components/ComponentLibrary/SectionCL';

export default function CommentSection({id, className = undefined, ...props}) {
  const [commentsKey, setCommentsKey] = useState(0);
  const refreshComments = useCallback(() => setCommentsKey((commentsKey) => commentsKey + 1), []);

  return (
    <SectionCL
      id={classNames(id)}
      color="white"
      className={classNames(`section-comments`, className)}
      angle="none"
      order="last"
    >
      <Container>
        <Row className="d-flex align-items-center mb-4 mb-lg-5">
          <Col xs="12" lg="7" className="mb-4 mb-lg-0">
            <h3 className="section-heading">Share Your Comments & Reactions</h3>
            <p className="mb-0">
              To see the most recent comments, click the blue “GET THE LATEST COMMENTS” button below.
            </p>
          </Col>
          <Col xs="12" lg="5">
            <a className="comment-bubble d-flex flex-column justify-content-center" href="#comments">
              <div className="comment-bubble-inner my-auto">Post your comments and share your reactions.</div>
            </a>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="comment-box">
              <Row className="justify-content-end text-center mb-4">
                <Col xs="12" lg="5">
                  <Button className="btn btn-lg btn-refresh text-uppercase" onClick={refreshComments}>
                    Get The Latest Comments
                  </Button>
                </Col>
              </Row>
              <Row id="comment">
                <Col xs="12">
                  <FacebookCommentFeed {...props} key={commentsKey} />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </SectionCL>
  );
}

export function CommentSectionInline({...props}) {
  const [commentsKey, setCommentsKey] = useState(0);
  const refreshComments = useCallback(() => setCommentsKey((commentsKey) => commentsKey + 1), []);

  return (
    <div className={classNames(`comment-box-inline`)}>
      <div className="comment-box-inline-tools text-center mb-3">
        <Button className="btn btn-refresh text-uppercase" onClick={refreshComments}>
          Get The Latest Comments
        </Button>
      </div>
      <FacebookCommentFeed containerClass="p-0" {...props} key={commentsKey} />
    </div>
  );
}
